/* eslint-disable import/prefer-default-export */
import { GoalItemStatus, MentoringProgramGoalItem } from 'redux/schemas/models/mentoring-program-goal-items';

export const DEFAULT_GOAL_ITEM: MentoringProgramGoalItem = {
  id: 0,
  description: '',
  status: GoalItemStatus.JUST_STARTING,
};

export const getGoalStatusValues = (t) => ({
  [GoalItemStatus.JUST_STARTING]: t.MENTORING_PROGRAMS.PARTICIPANT_HOME.GOALS.ITEM.STATUS.JUST_STARTING(),
  [GoalItemStatus.MAKING_PROGRESS]: t.MENTORING_PROGRAMS.PARTICIPANT_HOME.GOALS.ITEM.STATUS.MAKING_PROGRESS(),
  [GoalItemStatus.SUBSTANTIAL_PROGRESS]: t.MENTORING_PROGRAMS.PARTICIPANT_HOME.GOALS.ITEM.STATUS.SUBSTANTIAL_PROGRESS(),
});
